import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as yup from "yup";
import { icons } from "../../../icons";
import { HeadLine3 } from "../../typography/styled";
import Button from "../../button";
import Input from "../../input";
import Toggle from "../../toggle";
import { clusterSettingsService } from "../../../api";
import { useUi } from "../../../context/ui.context";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
} from "../create-node-pool/styles";

type ModalProps = {
  closeModalCancel: () => void;
  closeModal: (data?: any) => void;
  dataToEdit?: any;
};

const CreateK8sVersion: FC<ModalProps> = ({ closeModal, closeModalCancel, dataToEdit }) => {
  const [t] = useTranslation();
  const { viewAlert } = useUi();
  const [loading, setLoading] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [visible, setVisible] = useState(dataToEdit?.visible ?? true);
  const isEdit = !!dataToEdit?.id;

  const onSubmit = (values: any) => {
    setLoading(true);
    const action = isEdit
      ? clusterSettingsService.updateVersion(dataToEdit.id, { visible })
      : clusterSettingsService.createVersion({ id: values.id, visible });

    action
      .then(() => {
        setLoadingComplete(true);
        setTimeout(() => {
          closeModal({ success: true });
          setLoading(false);
          setLoadingComplete(false);
        }, 1500);
      })
      .catch((err) => {
        setLoading(false);
        viewAlert({
          severity: "error",
          message: err?.response?.data?.detail || t("ERROR_OCCURRED"),
        });
      });
  };

  const { values, errors, touched, handleSubmit, handleChange } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      id: isEdit ? yup.string() : yup.string().required(t("REQUIRED_FIELD")),
    }),
    initialValues: { id: dataToEdit?.id || "" },
    onSubmit,
  });

  return (
    <Container>
      <HeadWrapper>
        <HeadLine3 style={{ marginLeft: "10px", marginTop: "10px" }}>
          {isEdit ? t("EDIT_VERSION") : t("CREATE_VERSION")}
        </HeadLine3>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon} />
      </HeadWrapper>
      <BodyModal>
        {!isEdit && (
          <Input
            title={t("ID")}
            fieldName="id"
            value={values.id}
            handleChange={handleChange}
            errors={errors}
            touched={touched}
            required
          />
        )}
        <Toggle title={t("VISIBLE")} value={visible} onChange={() => setVisible(!visible)} />
        <div style={{ display: "flex", gap: "6px", marginTop: "6px" }}>
          <Button variant="stroke" size="display" customStyles={{ width: "177px", justifyContent: "center" }} onClick={closeModalCancel} title={t("CANCEL")} />
          <Button variant="primary" size="display" loading={loading} loadingComplete={loadingComplete} customStyles={{ width: "177px", justifyContent: "center" }} onClick={handleSubmit} title={isEdit ? t("SAVE") : t("CREATE")} />
        </div>
      </BodyModal>
    </Container>
  );
};

export default CreateK8sVersion;
